import { productVariantSelectorChangeEvent, productVariantSelectorName, } from '@/components/ui';
import { Section, defineSection } from '@decify/cell-shopify/client';
import './product-overview.scss';
export const productOverviewName = 'ProductOverview';
export const productOverviewTagName = 'cell-section-product-overview';
export class ProductOverview extends Section {
    templateCache;
    constructor() {
        super(productOverviewName);
        this.templateCache = new Map();
        this.handleProductVariantChange = this.handleProductVariantChange.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${productVariantSelectorName}.${productVariantSelectorChangeEvent}`, this.handleProductVariantChange);
    }
    async handleProductVariantChange(data) {
        const { selectedProductVariant } = data;
        // TODO: Disable relevant actions like buy_buttons to prevent conflicts.
        const template = await this.getTemplateForProductVariant(selectedProductVariant.id);
        // TODO: Fix this type error.
        // @ts-ignore
        this.innerHTML = template.getElementById(`shopify-section-${this.props.sectionId}`).innerHTML;
    }
    async getTemplateForProductVariant(selectedProductVariantId) {
        let template = this.templateCache.get(selectedProductVariantId);
        if (!template) {
            template = await this.fetchTemplateForProductVariant(selectedProductVariantId);
            this.templateCache.set(selectedProductVariantId, template);
        }
        return template;
    }
    async fetchTemplateForProductVariant(selectedProductVariantId) {
        const response = await fetch(window.location.pathname +
            '?variant=' +
            selectedProductVariantId +
            '&section_id=' +
            this.props.sectionId);
        const responseText = await response.text();
        const template = new DOMParser().parseFromString(responseText, 'text/html');
        return template;
    }
}
defineSection(productOverviewTagName, ProductOverview);
